(function(){
  'use strict';

  function makeAnnouncementMove(header){
    var track=header.querySelector('.nv-announcement__track');
    if(!track||track.getAttribute('data-nuvio-marquee')==='true') return;
    track.setAttribute('data-nuvio-marquee','true');

    var group=document.createElement('div');
    group.className='nv-announcement__group';
    while(track.firstChild) group.appendChild(track.firstChild);
    var separator=document.createElement('i');
    separator.setAttribute('aria-hidden','true');
    separator.textContent='•';
    group.appendChild(separator);
    var clone=group.cloneNode(true);
    clone.setAttribute('aria-hidden','true');
    track.appendChild(group);
    track.appendChild(clone);
    track.classList.add('is-nuvio-marquee');
  }

  function bindSticky(header){
    if(header.getAttribute('data-nuvio-sticky-enhanced')==='true') return;
    header.setAttribute('data-nuvio-sticky-enhanced','true');
    function update(){header.classList.toggle('is-nuvio-scrolled',window.scrollY>8);}
    window.addEventListener('scroll',update,{passive:true});
    update();
  }

  function boot(scope){
    var header=(scope||document).querySelector&&((scope||document).querySelector('[data-nuvio-header]'));
    if(!header) header=document.querySelector('[data-nuvio-header]');
    if(!header) return;
    bindSticky(header);
    makeAnnouncementMove(header);
  }

  var style=document.createElement('style');
  style.textContent='\n    [data-nuvio-header]{position:sticky!important;top:0!important;z-index:500!important;isolation:isolate;transition:box-shadow .24s ease,background-color .24s ease}\n    [data-nuvio-header].is-nuvio-scrolled{box-shadow:0 10px 30px -20px rgba(24,20,17,.75),0 1px 0 rgba(31,27,23,.08)!important}\n    [data-nuvio-header] .nv-announcement{overflow:hidden!important}\n    [data-nuvio-header] .nv-announcement__track.is-nuvio-marquee{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:0!important;width:max-content!important;min-width:100%!important;padding:0!important;overflow:visible!important;white-space:nowrap!important;animation:nuvioAnnouncementMarquee 28s linear infinite!important;will-change:transform}\n    [data-nuvio-header] .nv-announcement__group{display:flex;align-items:center;flex:none;gap:38px;padding:0 38px}\n    [data-nuvio-header] .nv-announcement__track.is-nuvio-marquee:hover{animation-play-state:paused!important}\n    @keyframes nuvioAnnouncementMarquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}\n    @media(max-width:900px){[data-nuvio-header] .nv-announcement__track.is-nuvio-marquee{animation-duration:22s!important;overflow:visible!important}[data-nuvio-header] .nv-announcement__group{gap:22px;padding:0 22px}}\n    @media(prefers-reduced-motion:reduce){[data-nuvio-header] .nv-announcement__track.is-nuvio-marquee{animation:none!important;transform:none!important}}\n  ';
  document.head.appendChild(style);

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();
